import type { Agency, AgencyListTab } from '@saaga/shared/interfaces/agencies.interface'
import type { AgencyListParams } from '@saaga/shared/interfaces/agency.interface'
import { useGetAgenciesQuery } from '@saaga/shared/store/api.store'
import { useMemo } from 'react'

import { mapAgencyListToAgencyList } from './agency-response-mapper.util'

export interface UseAgenciesDataReturn {
  agencyList: Agency[]
  isLoading: boolean
  isError: boolean
}

const tabToVisibilityParams: Record<AgencyListTab, AgencyListParams> = {
  explore: { visibilityList: ['public'] },
  studio: { visibilityList: ['draft'] },
  organization: { visibilityList: ['private', 'pending_review', 'rejected'] },
  templates: {},
}

export const useAgenciesData = (
  activeTab: AgencyListTab,
  category?: string
): UseAgenciesDataReturn => {
  const baseParams = tabToVisibilityParams[activeTab]
  const params = useMemo(
    (): AgencyListParams => (category ? { ...baseParams, category } : baseParams),
    [baseParams, category]
  )

  const { data, isLoading, isError } = useGetAgenciesQuery(params)

  const agencyList = useMemo(() => {
    if (!data) {
      return []
    }
    return mapAgencyListToAgencyList(data, activeTab === 'explore')
  }, [data, activeTab])

  return {
    agencyList,
    isLoading,
    isError,
  }
}
